export default __webpack_public_path__ + "static/media/InsideLungs_03.abb2c6fc.png";